import z from 'zod';
import { OPERATIONS, RESOURCES } from '../constants.js';
//`.or(z.string())` used for forward compatibility
const resource = z.enum(RESOURCES).or(z.string());
const operation = z.enum(OPERATIONS);
const permission = z.object({
    resource: resource,
    operation: operation,
});
const role = z.string();
export const permissionTreeSchema = z.object({
    rolesByLocation: z.record(z.string(), z.array(role)),
    permissionsByRole: z.record(role, z.array(z.string())),
    permissionsById: z.record(z.string(), permission),
});
//# sourceMappingURL=auth-service.validator.js.map